import React from 'react'
import { RemoteStats } from '../Trends/RemoteStats'

function RemoteStat() {
  return (
    <>
        <RemoteStats />
    </>
  )
}

export default RemoteStat
